import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M32.764 6.836a4 4 0 0 1 3.471 0l19.593 9.435a4 4 0 0 1 2.165 2.714l4.839 21.201a4 4 0 0 1-.773 3.384L48.501 60.572a4 4 0 0 1-3.128 1.507H23.627a4 4 0 0 1-3.128-1.507L6.941 43.57a4 4 0 0 1-.773-3.384l4.84-21.2a4 4 0 0 1 2.164-2.715l19.592-9.435z",
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M27.765.836a4 4 0 0 1 3.47 0l19.593 9.435a4 4 0 0 1 2.165 2.714l4.839 21.201a4 4 0 0 1-.773 3.384L43.501 54.572a4 4 0 0 1-3.128 1.507H18.627a4 4 0 0 1-3.128-1.507L1.941 37.57a4 4 0 0 1-.773-3.384l4.84-21.2a4 4 0 0 1 2.164-2.715L27.765.836z",
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M33 42h1.62C39.8 42 44 37.8 44 32.62v0c0-5.18-4.2-9.38-9.38-9.38H14m0 0L21.26 16M14 23.24l7.26 7.241",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 64,
    height: 65,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-reverse-effects.d758efc5.svg";
export { SvgComponent as ReactComponent };